export const GET_DISTRIBUTION_SETS = 'distributions/GET_DISTRIBUTION_SETS';
export const GET_DISTRIBUTION_SETS_SUCCESS = 'distributions/GET_DISTRIBUTION_SETS_SUCCESS';
export const GET_DISTRIBUTION_SETS_FAILED = 'distributions/GET_DISTRIBUTION_SETS_FAILED';
